"use client";

import React, { useState, useEffect } from "react";
import { Link } from "@/components/common/Link";
import { cn } from "@/lib/utils";
export default function LincantoDellaLuce() {
  const [isMounted, setIsMounted] = useState(false);
  useEffect(() => {
    setIsMounted(true);
  }, []);
  return <section id="lincanto-della-luce" className="relative h-screen w-full overflow-hidden dark bg-background text-foreground">
      {}
      <div className="absolute inset-0 z-0 bg-black">
        {isMounted && <video src="/videos/developing-process.mp4" autoPlay loop muted playsInline className="h-full w-full object-cover opacity-60 grayscale contrast-125" poster="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1562462/img/developing_portrait_poster.png" />}
        {}
        <div className="absolute inset-0 -z-10 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1562462/img/developing_portrait_poster.png)] bg-cover bg-center opacity-60 grayscale contrast-125" />
      </div>

      {}
      <div className="absolute inset-0 z-10 bg-gradient-to-b from-black/40 via-transparent to-black/80" />

      {}
      <div className="relative z-20 flex h-full flex-col items-center justify-center px-4 text-center">
        <div className="max-w-5xl space-y-8">
          {}
          <h1 className="font-serif text-6xl font-medium tracking-tighter text-white sm:text-7xl md:text-8xl lg:text-9xl">The Magic of Light</h1>

          {}
          <p className="mx-auto max-w-2xl font-mono text-lg text-white/90 md:text-xl">Slow photography is a ritual. Rediscover the value of waiting with authentic portraits on analog paper, handcrafted and developed before your eyes. A timeless experience, captured forever.</p>
        </div>
      </div>

      {}
      <div className="absolute bottom-0 left-1/2 z-30 flex -translate-x-1/2 flex-col items-center pb-8">
        <div className="h-24 w-[2px] animate-pulse rounded-full bg-primary shadow-[0_0_15px_rgba(255,165,0,0.6)]" />
      </div>
    </section>;
}